export const GET_CURRENT_TRENDING_SONGS =  'CURRENT_TRENDING_SONGS';
export const GET_TRENDING_TRACK_ALBUMS =  'GET_TRENDING_TRACK_ALBUMS';
export const GET_TRENDING_TRACK_SONGS =  'GET_TRENDING_TRACK_SONGS';
